import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, getToken, setToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [state, setState] = useState({ user: undefined, company: null });

  const refresh = useCallback(async () => {
    if (!getToken()) return setState({ user: null, company: null });
    try {
      const { data } = await api.get("/auth/me");
      setState({ user: data.user, company: data.company, logoVersion: Date.now() });
    } catch {
      setToken(null);
      setState({ user: null, company: null });
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const signIn = (data) => {
    setToken(data.token);
    setState({ user: data.user, company: data.company, logoVersion: Date.now() });
  };
  const signOut = () => {
    setToken(null);
    setState({ user: null, company: null });
  };
  const setCompany = (company) => setState((s) => ({ ...s, company, logoVersion: Date.now() }));
  const setCredits = useCallback((credits) => setState((s) => (s.company && typeof credits === "number" ? { ...s, company: { ...s.company, credits } } : s)), []);
  const refreshCredits = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setCredits(data.company?.credits);
    } catch { /* balance refresh is best-effort */ }
  }, [setCredits]);

  return (
    <AuthContext.Provider value={{ ...state, refresh, signIn, signOut, setCompany, setCredits, refreshCredits }}>{children}</AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
